import { Trans } from 'react-i18next'

import { FormatPrice } from '@reveni-io/reveni-ui'

const InstantOPMText = ({ orderAmount }) => {
  return (
    <>
      <p>
        <Trans
          i18nKey="opmProcessCompletedMessage"
          values={{ amount: orderAmount?.remaining_amount || 0 }}
          defaults="Te hemos hecho un reembolso por valor de los <strong><price>{{amount}}</price></strong> de tu devolución. Lo recibirás en 3 días hábiles o menos, dependiendo del método de pago que usaste en tu compra."
          components={{ strong: <strong />, price: <FormatPrice currency={orderAmount?.currency || 'EUR'} /> }}
        />
      </p>
    </>
  )
}

export default InstantOPMText
